const SEPARATOR = ':'

export const useStorage = (initStorage: Storage) => {
  const storage = initStorage

  const getStorage = (keys: number | string | (string | number | undefined)[]) => {
    const parsedKey = Array.isArray(keys) ? keys?.join(SEPARATOR) : String(keys) || ''
    return storage.getItem(parsedKey)
  }

  const setStorage = (keys: number | string | (string | number | undefined)[], value: string | number) => {
    const parsedKey = Array.isArray(keys) ? keys?.join(SEPARATOR) : String(keys) || ''
    return storage.setItem(parsedKey, String(value))
  }

  const removeStorage = (keys: number | string | (string | number | undefined)[]) => {
    const parsedKey = Array.isArray(keys) ? keys?.join(SEPARATOR) : String(keys) || ''
    return storage.removeItem(parsedKey)
  }

  const clearStorage = () => {
    storage.clear()
  }

  return {
    getStorage,
    setStorage,
    removeStorage,
    clearStorage,
  }
}

export const useLocalStorage = () => {
  return useStorage(localStorage)
}

export const useSessionStorage = () => {
  return useStorage(sessionStorage)
}

export default useStorage
